import { NavItem } from '@unicup-ticketing/core';

export const customerNavItems: NavItem[] = [
  { name: 'Ablauf', path: 'about-the-draw' },
  { name: 'FAQ', path: 'faq' },
  { name: 'Kontakt', path: 'contact' },
];
